<template>
    <footer class="tpl-foot-wrap">
        <div class="public-radius-wrap">
            <div class="public-radius-box tpl-foot-form-box">
                <div class="tpl-foot-title">
                    <header>在线领取创业开店指南</header>
                    <p>已有<span>2256人</span>成功领取</p>
                    <ul onclick="zixun()">
                        <li>
                            <i></i>
                            <h3>课程学习<br />资料</h3>
                        </li>
                        <li>
                            <i></i>
                            <h3>学费文档<br />资料</h3>
                        </li>
                        <li>
                            <i></i>
                            <h3>创业开店<br />指南</h3>
                        </li>
                        <li>
                            <i></i>
                            <h3>校园环境<br />视频</h3>
                        </li>
                    </ul>
                </div>
                <section class="tpl-foot-baoming">
                    <ul>
                        <li>
                            <i class="tpl-foot-name-icon"></i>
                            <input v-model="foot_sub_name" name="uname" type="text" placeholder="请输入您的姓名">
                        </li>
                        <li>
                            <i class="tpl-foot-tell-icon"></i>
                            <input v-model="foot_sub_tel" name="tel" type="number" placeholder="请输入您的电话">
                        </li>
                    </ul>
                    <div class="tpl-foot-prompt">
                        <p><i></i>我们将对您提交的信息严格保密。</p>
                    </div>
                    <a class="tpl-foot-btn" href="javascript:void(0)" @click="pubXdxcSubWb()">提交领取</a>
                </section>
            </div>
        </div>
        <div class="public-radius-wrap">
            <div class="public-radius-box">
                <!-- 来校路线 -->
                <section class="tpl-foot-way-box">
                    <ul>
                        <li>
                            <i></i>
                        </li>
                        <li>
                            <p>咨询热线：<a href="tel:0871-65812999"></a>0871-65812999</p>
                            <p>车家壁校区：昆明市西山区车家壁</p>
                        </li>
                    </ul>
                    <div class="copyright-des">
                        <p>ICP备案：<a href="https://beian.miit.gov.cn/">滇ICP备17001176号-1</a></p>
                        <p>版权所有©：北京朗杰科技有限公司</p>
                    </div>
                </section>
            </div>
        </div>   
        <section class="tpl-foot-fixed-box">
            <ul>
                <li>
                    <a href="javascript:void(0)" onclick="zixun()" title="优惠详情">
                        <i></i>
                        <p>优惠详情</p> 
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" onclick="zixun()" title="在线咨询学费">
                        <i></i>
                        <p>在线咨询学费</p> 
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" onclick="zixun()" title="培训项目">
                        <i></i>
                        <p>培训项目</p> 
                    </a>
                </li>
            </ul>
            <!-- 模拟移动layer信息提示 -->
            <div class="public-custom-layer-tips" ref="pubCustomLayerTip" v-show="show === 'show'">
                <h3>{{ foot_msg }}</h3>
            </div>
        </section>
    </footer>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
export default {
    name: 'pubFoot',
    data(){
        return {
            foot_sub_name: '', // 姓名
            foot_sub_tel: '', //  电话
            interestValue: '', // 选择的专业
            show: 'hide',
            foot_msg: '信息错误'
        }
    },
    methods:{
        showPubCustomLayer(propMsg){
            let This = this;
            let pubCustomLayerTip = this.$refs.pubCustomLayerTip;
            this.show = "show";
            this.foot_msg = propMsg? propMsg : "信息错误";
            pubCustomLayerTip.addEventListener('animationend', function (){
                setTimeout(()=>{
                    This.show = "hide";
                    This.foot_msg = "信息错误";
                },1000)
            })
        },
        pubXdxcSubWb(){
            let This = this;
            if(This.foot_sub_name === ''){
                This.showPubCustomLayer('请填写姓名');
                return;
            }
            if( ! (/^1[3456789]\d{9}/g.test( This.foot_sub_tel )) ){
                This.showPubCustomLayer('手机号不正确');
                return;
            }
            let postURL = 'http://wb.ynxdfpr.com/bm.php?uname='+This.foot_sub_name+'&tel='+This.foot_sub_tel+'&jp='+This.interestValue+'&fromurl='+window.location.href+'';
            // console.log(postURL)
            this.axios.get(postURL).then((response) => {
                console.log(response.data)
                if(response.data){
                    This.showPubCustomLayer('提交成功，请耐心等待！');
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
// 初始化设计图尺寸 注意：less 除法要用小括号括起来
@rem: 40rem;
@w100: (640/@rem);
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: (@w/@rem);
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: (@radius/@rem) (@radius/@rem) (@radius/@rem) (@radius/@rem);
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: (@lineHeight/@rem);
    font-size: (@fontSize/@rem);
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: (@h/@rem);
        }
    }
}
// 规定最大宽度
html,body{
    max-width: 640px;
    margin: 0 auto;
    overflow-x: hidden;
}
// xdxc foot
.tpl-foot-wrap{
    background: #f1f1f1;
    padding-top: (30/@rem);
    padding-bottom: (110/@rem);
    .tpl-foot-form-box{
        padding: (10/@rem) 0;
    }
    .tpl-foot-title{
        header{
            .linefont(60, 30, #000);
            text-align: center;
            font-weight: bold;
        }
        p{
            .linefont(30, 20, #000);
            span{
                .linefont(30, 20, #d83538);
            }
        }
        ul{
            .auto(555);
            margin-top: (20/@rem);
            &:extend(.justify);
            li{
                i{
                    display: block;
                    .auto(70);
                    height: (60/@rem);
                    .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/book-icon.png');
                }
                &:nth-of-type(2){
                    i{
                        .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/doc-icon.png');
                    }
                }
                &:nth-of-type(3){
                    i{
                        .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/pdf-icon.png');
                    }
                }
                &:nth-of-type(4){
                    i{
                        .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/play-icon.png');
                    }
                }
                h3{
                    .linefont(30, 20, #000);
                    text-align: center;
                    margin-top: (10/@rem);
                }
            }
        }
    }
    .tpl-foot-baoming{
        ul{
            .auto(550);
            li{
                position: relative;
                margin-top: (15/@rem);
                i{
                    display: block;
                    width: (30/@rem);
                    height: (30/@rem);
                    position: absolute;
                    top: 50%;
                    left: (20/@rem);
                    transform: translateY(-50%);
                }
                .tpl-foot-name-icon{
                    .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/name.png');
                }
                .tpl-foot-tell-icon{
                    .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/tell.png');
                }
                input{
                    display: block;
                    width: 100%;
                    .linefont(60, 22, #454545);
                    text-indent: (60/@rem);
                    .radius(10);
                    background: #eeeeee;
                    border: 1px solid #aaaaaa;
                    &::placeholder{
                        .linefont(60, 22, #626262);
                    }
                }
            }
        }
        .tpl-foot-prompt{
            margin: (10/@rem) 0;
            p{
                i{
                    display: inline-block;
                    width: (25/@rem);
                    height: (25/@rem);
                    .backgroundUrl('/assets/img/home/ixion/foot/protect.png');
                    vertical-align: (-5/@rem);
                    margin-right: (10/@rem);
                }
                .linefont(60, 20, #000);
                text-align: center;
            }
        }
        .tpl-foot-btn{
            display: block;
            .auto(550);
            .linefont(60, 22, #fff);
            background: linear-gradient(to right, #f75052 30%, #d83538);
            .radius(30);
        }
    }
    .tpl-foot-way-box{
        margin-top: (30/@rem);
        padding-top: (15/@rem);
        ul{
            &:extend(.justify);
            li{
                &:nth-of-type(1){
                    width: (168/@rem);
                    position: relative;
                    margin-right: (15/@rem);
                    i{
                        display: block;
                        width: 100%;
                        height: (116/@rem);
                        .backgroundUrl('/assets/img/home/ixion/foot/sub-icon/way-icon.jpg');
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                &:nth-of-type(2){
                    flex: 1;
                    padding-top: (15/@rem);
                    p{
                        .linefont(48, 20, #000); 
                        text-align: left;
                        a{
                            .linefont(38, 20, #000); 
                        }
                    }
                }
            }
        }
        .copyright-des{
            padding-top: (20/@rem);
            p{
                .linefont(30, 18, #6e6e6e);
                text-align: center;
            }
        }
    }
    .tpl-foot-fixed-box{
        background: #f9d9bb;
        position: fixed;
        bottom: 0;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
        max-width: 640px;
        z-index: 8;
        ul{
            &:extend(.justify);
            li{
                width: (150/@rem);
                height: (97/@rem);
                text-align: center;
                position: relative;
                i{
                    display: block;
                    .auto(40);
                    height: (40/@rem);
                    margin-top: (15/@rem);
                }
                a{
                    display: block;
                    p{
                        .linefont(25, 24, #434343);
                        padding-top: (5/@rem);
                    }
                }
                &:nth-of-type(1){
                    i{
                        .backgroundUrl('/assets/img/home/ixion/foot/fix-foot/1.png');
                    }
                }
                &:nth-of-type(2){
                    flex: 1;
                    background: #d83538;
                    position: relative;
                    i{
                        width: (100/@rem);
                        height: (62/@rem);
                        margin-top: 0;
                        position: absolute;
                        top: (-20/@rem);
                        left: 50%;
                        transform: translateX(-50%);
                        width: (100/@rem);
                        .backgroundUrl('/assets/img/home/ixion/foot/fix-foot/2.png');
                    }
                    a{
                        p{
                            color: #fff;
                            margin-top: (53/@rem);
                        }
                    }
                }
                &:nth-of-type(3){
                    i{
                        .backgroundUrl('/assets/img/home/ixion/foot/fix-foot/3.png');
                    }
                }
            }
        }
    }
}
// 模拟移动layer信息提示
.public-custom-layer-tips{
    // display: none;
    width: (600/@rem);
    height: (80/@rem);
    position: absolute;
    top: (-120/@rem);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0,0,0,.7);
    .radius(10);
    animation: rubberBand 1s ease;
    h3{
        .linefont(80, 25, #fff);
        text-align: center;
    }
}
@keyframes rubberBand {
    from {
      -webkit-transform: scale3d(1, 1, 1) translateX(-50%);
      transform: scale3d(1, 1, 1) translateX(-50%);
    }
  
    30% {
      -webkit-transform: scale3d(1.25, 0.75, 1) translateX(-40%);
      transform: scale3d(1.25, 0.75, 1) translateX(-40%);
    }
  
    40% {
      -webkit-transform: scale3d(0.75, 1.25, 1) translateX(-65%);
      transform: scale3d(0.75, 1.25, 1) translateX(-65%);
    }
  
    50% {
      -webkit-transform: scale3d(1.15, 0.85, 1) translateX(-43%);
      transform: scale3d(1.15, 0.85, 1) translateX(-43%);
    }
  
    65% {
      -webkit-transform: scale3d(0.95, 1.05, 1) translateX(-53%);
      transform: scale3d(0.95, 1.05, 1) translateX(-53%);
    }
  
    75% {
      -webkit-transform: scale3d(1.05, 0.95, 1) translateX(-48%);
      transform: scale3d(1.05, 0.95, 1) translateX(-48%);
    }
  
    to {
      -webkit-transform: scale3d(1, 1, 1) translateX(-50%);
      transform: scale3d(1, 1, 1) translateX(-50%);
    }
}
</style>